import { useState, useEffect } from "react"
import { APP_URL, coreStore } from "@forcepoint/platform-coreui"

async function evaluateFeatureFlag(key) {
  try {
    const coreState = coreStore.getState()
    const userResponse = coreState.userInfo
    const userToken = coreState.userToken
    const gtenantId = userResponse?.ext?.tenantId.find(
      (a) => a.hint.toLowerCase() === "global"
    )?.id
    const userId = userResponse?.sub
    const groups = userResponse?.groups

    const ffReqData = {
      tenantId: gtenantId,
      userId: userId,
      UserGroupIds: groups
    }
    const res = await fetch(`${APP_URL}/api/feature_flags/${key}/evaluations`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`
      },
      body: JSON.stringify(ffReqData)
    })

    const data = await res.json()

    // if there is no valid response from the API
    if (!data.result) {
      console.error(`Invalid response for ${key} featureflag: `, data)
    }

    return data
  } catch (error) {
    console.error(`Error evaluating ${key} featureflag: `, error)
  }
}

export function useFeatureFlag(key: string) {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let isCancelled = false

    async function evaluateFlag() {
      try {
        setIsLoading(true)
        setError(null)

        const result = await evaluateFeatureFlag(key)

        if (!isCancelled) {
          setData(result)
        }
      } catch (err) {
        if (!isCancelled) {
          setError(err)
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false)
        }
      }
    }

    const coreState = coreStore.getState()
    if (coreState.userToken && coreState.userInfo) {
      evaluateFlag()
    } else {
      setIsLoading(false)
    }

    return () => {
      isCancelled = true
    }
  }, [key])

  return { data, isLoading, error }
}
